import { render, staticRenderFns } from "./blogsCom.vue?vue&type=template&id=5a1c38a7&scoped=true"
import script from "./blogsCom.vue?vue&type=script&lang=js"
export * from "./blogsCom.vue?vue&type=script&lang=js"
import style0 from "./blogsCom.vue?vue&type=style&index=0&id=5a1c38a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1c38a7",
  null
  
)

export default component.exports